import { render, staticRenderFns } from "./ResourcePanelViewItem.vue?vue&type=template&id=13b8a046&scoped=true&"
import script from "./ResourcePanelViewItem.vue?vue&type=script&lang=js&"
export * from "./ResourcePanelViewItem.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePanelViewItem.vue?vue&type=style&index=0&id=13b8a046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8a046",
  null
  
)

export default component.exports